let slotsToRefresh,
	slotsToWatch,
	viewThreshold;

function init(cfgViewThreshold = 300) {
	slotsToRefresh = [];
	slotsToWatch = [];
	viewThreshold = cfgViewThreshold;

	window.advert.pubsub.subscribe('slot.hasImpressionUpdated', _onImpressionUpdate);
	window.advert.pubsub.subscribe('scroll', _onScroll);
}

function _onImpressionUpdate(slot) {
	if (slot.refreshable && slot.hasImpression && slotsToWatch.indexOf(slot) === -1) {
		slotsToWatch.push(slot);
	}
}

function _onScroll() {
	slotsToWatch = slotsToWatch.filter((slot) => {
		if (!window.advert.screen.isInView(slot.node, viewThreshold)) {
			slotsToRefresh.push(slot);

			return false;
		}

		return true;
	});

	slotsToRefresh = slotsToRefresh.filter((slot) => {
		if (window.advert.screen.isInView(slot.node, viewThreshold)) {
			slot.refresh();

			return false;
		}

		return true;
	});
}

module.exports = {
	init
};
